import { render, staticRenderFns } from "./MultiWhatsappChannelDetail.vue?vue&type=template&id=f7c5c864&scoped=true"
import script from "./MultiWhatsappChannelDetail.vue?vue&type=script&lang=js"
export * from "./MultiWhatsappChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./MultiWhatsappChannelDetail.vue?vue&type=style&index=0&id=f7c5c864&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7c5c864",
  null
  
)

export default component.exports